import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

import * as types from './mutation-types';

export function fetchBookmarksVideoLectures({ dispatch }, filters = {}) {
  return http.get(`${MINERVA_API_URL}/users/me/bookmarks/video-lectures`, { params: filters })
    .then(res => (
      dispatch('setBookmarksLectures', {
        bookmarksLectures: res.data,
        lectureType: filters.lectureType || 1,
      })
    ));
}

export function resetBookmarks({ commit }) {
  commit(types.RESET_BOOKMARKS);
}

export function resetBookmarksPosition({ commit }) {
  commit(types.RESET_BOOKMARKS_POSITION);
}

export function fetchBookmarksCardLectures({ dispatch }, filters = {}) {
  return http.get(`${MINERVA_API_URL}/users/me/bookmarks/card-lectures`, { params: filters })
    .then(res => (
      dispatch('setBookmarksLectures', {
        bookmarksLectures: res.data,
        lectureType: filters.lectureType || 2,
      })
    ));
}

export function setBookmarksLectures({ commit }, { bookmarksLectures, lectureType }) {
  commit(types.SET_BOOKMARKS_LECTURES, { bookmarksLectures, lectureType });

  return Promise.resolve(bookmarksLectures);
}



// WEBPACK FOOTER //
// ./src/app/bookmark/store/actions.js